'use strict';
import * as $i_$002fsrc$002fmain$002fjs$002fenv$002ejs from "/src/main/js/env.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_SiteInfo$() {
  this.dk = null;
  this.bJ = null;
  this.sL = null;
  this.ft = null;
  this.sK = null;
  this.sG = null;
  this.sJ = null;
  this.sI = null;
  this.sH = null;
  this.cH = null;
  $n_Lio_intela_sites_digitalinternship_SiteInfo$ = this;
  this.dk = "Digital Internship";
  this.bJ = "Vorkis LLC";
  this.sL = "Gain real experience before your first job";
  this.ft = "Digital Internship by Vorkis: real workplace practice with a hybrid human + AI team. Build verified skills and a job-ready portfolio.";
  this.sK = "Vorkis LLC \u2014 registered office available on request at privacy@digitalinternship.ai";
  this.sG = "Digital Internship \u2014 Job-Ready Skills Before Your First Job";
  this.sJ = "/videos/vorkis_DI.mp4";
  this.sI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("Open edX", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("Skills Network", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("IBM", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
  this.sH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_intela_sites_kit_seo_Organization(this.bJ, this.bJ, $i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.siteUrl, "sales@digitalinternship.ai", "/brand/logo.svg", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("https://linkedin.com/company/vorkis", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("https://x.com/vorkis", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("https://github.com/vorkis", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
  this.cH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_intela_sites_kit_seo_Site(this.dk, $i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.siteUrl, this.ft, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Lio_intela_sites_kit_i18n_Locale$__En__Lio_intela_sites_kit_i18n_Locale(), this.sH, "/brand/og.png", "/brand/favicon.svg", (!(!$i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.noIndex)));
}
export { $c_Lio_intela_sites_digitalinternship_SiteInfo$ as $c_Lio_intela_sites_digitalinternship_SiteInfo$ };
$p = $c_Lio_intela_sites_digitalinternship_SiteInfo$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_SiteInfo$;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_SiteInfo$() {
}
export { $h_Lio_intela_sites_digitalinternship_SiteInfo$ as $h_Lio_intela_sites_digitalinternship_SiteInfo$ };
$h_Lio_intela_sites_digitalinternship_SiteInfo$.prototype = $p;
$p.aF = (function() {
  return $i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.siteUrl;
});
$p.hm = (function() {
  return $i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.authUrl;
});
var $d_Lio_intela_sites_digitalinternship_SiteInfo$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_SiteInfo$, "io.intela.sites.digitalinternship.SiteInfo$", ({
  f5: 1
}));
export { $d_Lio_intela_sites_digitalinternship_SiteInfo$ as $d_Lio_intela_sites_digitalinternship_SiteInfo$ };
var $n_Lio_intela_sites_digitalinternship_SiteInfo$;
function $m_Lio_intela_sites_digitalinternship_SiteInfo$() {
  if ((!$n_Lio_intela_sites_digitalinternship_SiteInfo$)) {
    $n_Lio_intela_sites_digitalinternship_SiteInfo$ = new $c_Lio_intela_sites_digitalinternship_SiteInfo$();
  }
  return $n_Lio_intela_sites_digitalinternship_SiteInfo$;
}
export { $m_Lio_intela_sites_digitalinternship_SiteInfo$ as $m_Lio_intela_sites_digitalinternship_SiteInfo$ };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Site-Info$.js.map
